import { Controller } from '@hotwired/stimulus';

// The CDP SDK (Segment analytics.js under the hood) persists identity as `ajs_user_id` in both a
// cookie and localStorage under that exact key -- there is no separate "variant" key, and since
// the browser identify call never sends group() traits there is no ajs_group_id to clear either.
// `ajs_anonymous_id` can never merge twice (Customer.io's one-merge rule), so logout ROTATES it
// instead of preserving or deleting it -- the fresh id collects post-logout activity and merges
// at the next login.
const USER_ID_STORAGE_KEY = 'ajs_user_id';
const USER_ID_COOKIE_NAME = 'ajs_user_id';
const ANONYMOUS_ID_STORAGE_KEY = 'ajs_anonymous_id';
const ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
const COOKIE_DOMAIN = '.electionbuddy.com';
const ANONYMOUS_ID_COOKIE_MAX_AGE_SECONDS = 31536000;

// Post-logout renders through the `base` layout, where the CDP snippet never loads (see
// app/views/layouts/application.html.erb) -- so the clear has to happen here, synchronously, on
// the logout link's click, while this (application-layout) page still has the identity cookie in
// scope.
export default class extends Controller {
  public clear(): void {
    try {
      document.cookie = `${USER_ID_COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      window.localStorage.removeItem(USER_ID_STORAGE_KEY);
      document.cookie = `${ANONYMOUS_ID_COOKIE_NAME}=${crypto.randomUUID()}; domain=${COOKIE_DOMAIN}; path=/; max-age=${ANONYMOUS_ID_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax; secure`;
      window.localStorage.removeItem(ANONYMOUS_ID_STORAGE_KEY);
    } catch {
      // Never block logout (also covers crypto.randomUUID needing a secure context).
    }
  }
}
